import { render, staticRenderFns } from "./MiniDetail.vue?vue&type=template&id=5e03a31c&scoped=true&"
import script from "./MiniDetail.vue?vue&type=script&lang=js&"
export * from "./MiniDetail.vue?vue&type=script&lang=js&"
import style0 from "./MiniDetail.vue?vue&type=style&index=0&id=5e03a31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03a31c",
  null
  
)

export default component.exports